
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 14.327l.14-.37-.003-.416 2.396.727s.13-.152.085-.243c0-.092-.097-.292-.097-.292s-.137-.228-.366-.32c-.184-.09-1.918-1.139-1.918-1.139l.267-1.235.367-.228.092.137h.366s.367-.64.367-1.462-.092-.822-.092-.822h-.641l-.184.137.138-.32h1.467l4.171 1.188.459.457s-.275-.96-.275-1.279c-.642-.274-5.73-2.922-5.73-2.922l-.276-.457S8.371.673 7.5.673c-.917 0-.733 4.795-.733 4.795l-.276.457S1.403 8.573.761 8.847c0 .32-.275 1.279-.275 1.279l.459-.457 4.171-1.187h1.421l.138.32-.138-.275h-.641s-.092 0-.092.822.367 1.462.367 1.462h.32l.092-.137.367.228.275 1.37s-1.742.913-1.925 1.005c-.184.09-.367.32-.367.32s-.046.319-.092.41c-.046.092.092.229.092.229l2.384-.685v.41l.183.366z"}})])
          )
        }
      }
    